class PayAmountForDomestStayReq {
    constructor() {

        this.DomesticStayId = undefined;
        this.Amount = undefined;
        this.PaymentType = undefined;
        this.Amount = undefined;
        this.CreatorId = undefined;
    }
}
export default PayAmountForDomestStayReq;